var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1,17.86V10.07c0-.28.13-.67,1.14-1.45l.24-.18L4.14,6.92l-.21.16C2.56,8.12,2,9,2,10.07v7.8A4.15,4.15,0,0,0,6.13,22h1V19.93H6.09A2.05,2.05,0,0,1,4.1,17.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.78,7.53,14.89,2.84a3.82,3.82,0,0,0-4.78,0l-2,1.59L9.43,6.06l2-1.57a1.73,1.73,0,0,1,2.2,0l5.88,4.68a1.12,1.12,0,0,1,.44.89v7.8a2,2,0,0,1-2,2l-1.8,0V16.33A2.33,2.33,0,0,0,13.81,14H11.26a2.32,2.32,0,0,0-2.32,2.32L8.9,22H11L11,16.32a.27.27,0,0,1,.05-.15.2.2,0,0,1,.14-.06H13.8a.2.2,0,0,1,.2.2v3.53A2.15,2.15,0,0,0,16.15,22h1.7A4.13,4.13,0,0,0,22,17.86l0-7.81A3.25,3.25,0,0,0,20.78,7.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,6.59A1.41,1.41,0,1,0,4.34,5.18h0A1.41,1.41,0,0,0,5.75,6.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.aa72759aa37f4efb833e7b2bbedfd73f.svg";
export { ForwardRef as ReactComponent };